import client from './client';

export const sort = (payload) => client.post('/photos/sort', payload).then(r => r.data);
export const getStats = () => client.get('/photos/stats').then(r => r.data);
export const getAdminStats = () => client.get('/photos/admin/stats').then(r => r.data);
